import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { services } from "../services";
import { draCourseIds } from "../config";

const AddIibfExamDate = () => {
  const [formData, setFormData] = useState({
    examDate: "",
  });
  const [latestexamDate, setLatestExamDate] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const fetchLatestExamDate = async () => {
    try {
      const payload = { courseIds: draCourseIds };
      const res = await services.requestSvc.post(
        "/get-latest-exam-date",
        payload
      );
      console.log("ressss", res);
      if (res) {
        setLatestExamDate(res);
      }
    } catch (err) {
      console.error("❌ Error fetching latest exam date:", err);
    }
  };
  useEffect(() => {
    fetchLatestExamDate();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.examDate) {
      toast.warn("Please select examDate");
      return;
    }

    try {
      const payload = {
        examDate: formData?.examDate,
        courseIds: draCourseIds,
      };
      const success = await services.requestSvc.post(
        "/create-iibf-exam-date",
        payload
      );
      toast.success("exam date updated successfully!");

      setFormData({ examDate: "" });
      await fetchLatestExamDate();
    } catch (err) {
      console.error("❌ Error saving exam date:", err);
      toast.error("Failed to save exam date");
    }
  };
  const formatDate = (isoDate) => {
    if (!isoDate) return "-";
    const date = new Date(isoDate);
    return date.toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };
  return (
    <div className="min-h-screen bg-gray-100 p-10">
      <div className="bg-white rounded-xl shadow-md p-8 w-full mt-20">
        <h2 className="text-3xl font-semibold mb-8 text-center text-gray-800">
          Add IIBF Exam Date
        </h2>

        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
        >
          <div>
            <label className="block text-gray-700 font-medium mb-2">
              Exam Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              name="examDate"
              value={formData.examDate}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring focus:ring-blue-200"
            />
          </div>

          <div className="md:col-span-2 flex justify-end mt-6">
            <button
              type="submit"
              className="btn-primary text-white font-semibold py-2 px-6 rounded-lg  md:w-1/4 hover:bg-blue-700 transition duration-200"
            >
              Add Exam Date
            </button>
          </div>
        </form>
      </div>
      {latestexamDate ? (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-8">
          <h3 className="text-lg font-semibold text-blue-700 mb-2">
            Last Updated Exam Date
          </h3>
          <p className="text-gray-700">
            <strong>Date:</strong> {formatDate(latestexamDate.iibf_exam_date)}{" "}
          </p>
          <p className="text-gray-600 text-sm mt-1">
            Last Updated On:{" "}
            <span className="font-medium text-gray-800">
              {formatDate(latestexamDate.updated_at)}
            </span>
          </p>
        </div>
      ) : (
        <p className="text-gray-500 mb-6">No Exam date set yet.</p>
      )}
    </div>
  );
};

export default AddIibfExamDate;
